import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AdminEvaluadores from '../components/AdminEvaluadores'
import EvaluacionWizard from '../components/EvaluacionWizard'
import MisEvaluaciones from '../components/MisEvaluaciones'
import MisEvaluados from '../components/MisEvaluados'

const ListaEvaluacionesDesempeno = () => {
  const [selectedEvaluacion, setSelectedEvaluacion] = useState(null)
  const [selectedEvaluador, setSelectedEvaluador] = useState(null)
  const [selectedEvaluado, setSelectedEvaluado] = useState(null)
  const [showWizard, setShowWizard] = useState(false)
  const [loading, setLoading] = useState(false)
  const [viewAsAdmin, setViewAsAdmin] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handlePopState = () => {
      if (showWizard) {
        setShowWizard(false)
      } else if (selectedEvaluado) {
        setSelectedEvaluado(null)
      } else if (selectedEvaluador) {
        setSelectedEvaluador(null)
      } else {
        setSelectedEvaluacion(null)
      }
    }
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [showWizard, selectedEvaluado, selectedEvaluador])

  const handleCardClick = (procesoId) => {
    setSelectedEvaluacion(procesoId)
    navigate('/desempeno')
  }

  const handleEvaluadorClick = (evaluador) => {
    setSelectedEvaluador(evaluador)
    navigate('/desempeno')
  }

  const handleIrAEvaluacionClick = async (evaluado) => {
    setLoading(true)

    try {
      if (evaluado && evaluado) {
        setSelectedEvaluado(evaluado)
        setShowWizard(true)
        navigate('/desempeno')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleBackToEvaluations = () => {
    setShowWizard(false)
    setSelectedEvaluado(null)
    setSelectedEvaluador(null)
    setSelectedEvaluacion(null)
    setViewAsAdmin(false)
    navigate('/desempeno')
  }

  useEffect(() => {
    if (location.pathname === '/desempeno') {
      if (showWizard) {
        setShowWizard(false)
      } else if (selectedEvaluado) {
        setSelectedEvaluado(null)
      } else if (selectedEvaluador) {
        setSelectedEvaluador(null)
      } else {
        setSelectedEvaluacion(null)
      }
    }
  }, [location.pathname])

  return (
    <div>
      {loading && (
        <Box sx={{ p: 2, mb: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography>Cargando evaluación...</Typography>
        </Box>
      )}
      {showWizard ? (
        <EvaluacionWizard
          id={selectedEvaluado.id}
          evaluado={selectedEvaluado}
          evaluador={selectedEvaluador}
          onBack={() => setShowWizard(false)}
          onBackToEvaluaciones={handleBackToEvaluations}
        />
      ) : selectedEvaluacion !== null && selectedEvaluador ? (
        <MisEvaluados
          usuarioWeb={selectedEvaluacion}
          evaluador={selectedEvaluador}
          onEvaluadoClick={handleIrAEvaluacionClick}
          onBackToEvaluaciones={handleBackToEvaluations}
          onBack={() => setSelectedEvaluador(null)}
        />
      ) : selectedEvaluacion !== null && viewAsAdmin ? (
        <AdminEvaluadores
          procesoId={selectedEvaluacion}
          onEvaluadorClick={handleEvaluadorClick}
          onBack={() => setSelectedEvaluacion(null)}
        />
      ) : selectedEvaluacion !== null ? (
        <MisEvaluados
          usuarioWeb={selectedEvaluacion}
          onEvaluadoClick={handleIrAEvaluacionClick}
          onBackToEvaluaciones={handleBackToEvaluations}
        />
      ) : (
        <MisEvaluaciones
          onCardClick={handleCardClick}
          viewAsAdmin={viewAsAdmin}
          onToggleAdmin={setViewAsAdmin}
        />
      )}
    </div>
  )
}

export default ListaEvaluacionesDesempeno
